import {
    http,
    HttpNetworkError,
    type HttpRequestConfig,
} from '@inertiajs/core';

const backgroundErrors = new WeakSet<Error>();

/** Prefetch carries Purpose; other background callers can opt in explicitly. */
export function isBackgroundRequest(config: HttpRequestConfig): boolean {
    const headers = Object.fromEntries(
        Object.entries(config.headers ?? {}).map(([key, value]) => [
            key.toLowerCase(),
            value,
        ]),
    );
    return (
        headers.purpose === 'prefetch' ||
        headers['x-finzzo-background'] === 'true'
    );
}

export function isBackgroundNetworkError(error: Error): boolean {
    return backgroundErrors.has(error);
}

/** Preserve the request identity: a user reload may share a prefetch URL. */
export function registerBackgroundRequests(): void {
    const client = http.getClient();
    http.setClient({
        async request(config) {
            try {
                return await client.request(config);
            } catch (error) {
                if (
                    error instanceof HttpNetworkError &&
                    isBackgroundRequest(config)
                ) {
                    backgroundErrors.add(error);
                }
                throw error;
            }
        },
    });
}
